import { useEffect, useSyncExternalStore } from 'react';
import { getTerrainSettings, setTerrainSettings, subscribeTerrainSettings } from '../lib/terrain-settings';
import { terrainApi } from '../lib/terrain-api';

/** The project terrain settings (lib/terrain-settings.js) plus a setter. */
export default function useTerrainSettings() {
  const s = useSyncExternalStore(subscribeTerrainSettings, getTerrainSettings, getTerrainSettings);
  return { ...s, set: setTerrainSettings };
}

/**
 * Load the project's DEM link into the terrain store whenever the map's project changes
 * (GET /api/projects/{id}/terrain). Failures (feature off, migration 029 missing) leave
 * the project without a DEM; nothing else depends on it.
 */
export function useProjectTerrain(projectId) {
  useEffect(() => {
    if (!projectId) return undefined;
    let active = true;
    terrainApi.projectTerrain(projectId)
      .then((r) => {
        if (!active) return;
        const d = r.data || {};
        setTerrainSettings({ projectId, demDatasetId: d.dem ? d.dem_dataset_id : null, dem: d.dem || null });
      })
      .catch(() => { if (active) setTerrainSettings({ projectId, demDatasetId: null, dem: null }); });
    return () => { active = false; };
  }, [projectId]);
}
